export default __webpack_public_path__ + "5917d073ae0e5f82e1799897bef2a2f0.png";